import AgoraRTC from 'agora-rtc-sdk-ng'


const AgoraAppId = '9494a01769df40a2a23dc51c4681cd66'
//设置日志输出等级
AgoraRTC.setLogLevel(3)

export {
    AgoraAppId,
    AgoraRTC
}
